




























































import { Component, Prop, Vue } from "vue-property-decorator";
import MenuIconWithSelectionListComponent from "@/components/common/FilterMenu.vue";

/**
 * The top of every Mira page: the period picker (a calendar) and the comparison picker (the filter
 * icon) in the app bar, and the sticky header with the period, what it is compared with, and the run
 * date. `v-model` is the chosen period key.
 */
@Component({
  components: {
    "menu-icon": MenuIconWithSelectionListComponent,
  },
})
export default class MiraScreenHeaderComponent extends Vue {
  /** The chosen period key. */
  @Prop({ required: true })
  value!: string;

  @Prop({ required: true })
  periods!: string[];

  @Prop({ required: true })
  periodName!: (period: string) => string;

  @Prop({ required: true })
  periodDescription!: string;

  @Prop({ default: "" })
  comparisonDescription!: string;

  @Prop({ default: "" })
  generatedAtDescription!: string;

  /** The header card's colour, themed by the screen. */
  @Prop({ required: true })
  color!: string;

  /** The comparisons the Vergleich picker offers; one option hides the picker (only "Kein Vergleich"). */
  @Prop({ default: () => [] })
  comparisonOptions!: string[];

  /** The chosen comparison key. */
  @Prop({ default: "" })
  comparisonValue!: string;

  /** Names a comparison option for the picker. */
  @Prop({ default: () => (value: string) => value })
  comparisonName!: (value: string) => string;

  /** "Vergleich: Mandanten der Gruppe", appended to the first header line when a comparison is on. */
  @Prop({ default: "" })
  comparisonChoiceLabel!: string;

  /** The group membership caveat under the header, or empty where it does not apply. */
  @Prop({ default: "" })
  membershipNote!: string;
}
